/* Quantity modal for quick-add buttons on product cards (home + collections).
   Intercepts Dawn's single-variant quick-add, asks for quantity, then submits
   the original form so Dawn's product-form.js handles the add + cart popup.
   Product pages and the multi-variant "Choose options" flow are untouched. */
(function () {
  if (window.__qtyModalInit) return;
  window.__qtyModalInit = true;

  /* ---- styles ---- */
    var style = document.createElement('style');
  style.textContent = [
    '.qtym{position:fixed;inset:0;width:100vw;height:100vh;z-index:200;display:flex;',
    '  align-items:flex-start;justify-content:center;overflow-y:auto;',
    '  background:rgba(0,0,0,0);transition:background-color .15s linear}',
    '.qtym.is-open{background:rgba(0,0,0,.5)}',
    '.qtym[hidden]{display:none}',

    /* Overlay is now just the click-to-close hit area; backdrop color lives on .qtym */
    '.qtym__overlay{position:absolute;inset:0}',

    /* Dialog: fades + slides down like Bootstrap .modal.fade */
    '.qtym__dialog{position:relative;z-index:1;max-width:380px;width:calc(100% - 32px);',
    '  margin:20vh auto 40px;padding:24px;',
    '  background:rgb(var(--color-background,255 255 255));',
    '  border-radius:var(--popup-corner-radius,6px);text-align:center;',
    '  box-shadow:0 8px 32px rgba(0,0,0,.3);',
    '  opacity:0;transform:translateY(-50px);',
    '  transition:opacity .15s linear,transform .3s ease-out}',
    '.qtym.is-open .qtym__dialog{opacity:1;transform:translateY(0)}',

    '.qtym__title{margin:0 0 16px;font-size:1.15rem}',
    '.qtym__stepper{display:flex;justify-content:center;align-items:center;gap:8px;margin:0 0 20px}',
    '.qtym__stepper input{width:72px;text-align:center;padding:10px 4px;font-size:1rem;',
    '  border:1px solid rgba(var(--color-foreground,0 0 0),.35);border-radius:4px}',
    '.qtym__stepper button{width:42px;height:42px;font-size:1.25rem;cursor:pointer;',
    '  border:1px solid rgba(var(--color-foreground,0 0 0),.35);background:transparent;border-radius:4px}',
    '.qtym__actions{display:flex;gap:8px;justify-content:center}'
  ].join('\n');

  document.head.appendChild(style);

  /* ---- one shared modal, injected once ---- */
  var modal = document.createElement('div');
  modal.className = 'qtym';
  modal.hidden = true;
  modal.innerHTML =
    '<div class="qtym__overlay" data-qtym-close></div>' +
    '<div class="qtym__dialog" role="dialog" aria-modal="true">' +
      '<h3 class="qtym__title" data-qtym-title>Choose quantity</h3>' +
      '<div class="qtym__stepper">' +
        '<button type="button" data-qtym-step="-1" aria-label="Decrease quantity">&minus;</button>' +
        '<input type="number" value="1" min="1" inputmode="numeric" aria-label="Quantity">' +
        '<button type="button" data-qtym-step="1" aria-label="Increase quantity">+</button>' +
      '</div>' +
      '<div class="qtym__actions">' +
        '<button type="button" class="button button--secondary" data-qtym-close>Cancel</button>' +
        '<button type="button" class="button" data-qtym-add>Add to cart</button>' +
      '</div>' +
    '</div>';
  document.body.appendChild(modal);

  var input = modal.querySelector('input');
  var titleEl = modal.querySelector('[data-qtym-title]');
  var activeForm = null;

   function close() {
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { modal.hidden = true; activeForm = null; }, 200); /* let fade-out finish */
  }

  modal.addEventListener('click', function (e) {
    if (e.target.closest('[data-qtym-close]')) { close(); return; }

    var step = e.target.closest('[data-qtym-step]');
    if (step) {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.dataset.qtymStep, 10));
      return;
    }

    if (e.target.closest('[data-qtym-add]') && activeForm) {
      var qtyInput = activeForm.querySelector('input[name="quantity"]');
      if (!qtyInput) {
        qtyInput = document.createElement('input');
        qtyInput.type = 'hidden';
        qtyInput.name = 'quantity';
        activeForm.appendChild(qtyInput);
      }
      qtyInput.value = Math.max(1, parseInt(input.value, 10) || 1);
      var form = activeForm;
      close();
      /* Fires the submit event -> Dawn's product-form.js takes over:
         AJAX add with our quantity + native cart notification/drawer */
      if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) close();
  });

  /* ---- intercept single-variant quick-add buttons only ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.quick-add product-form button[type="submit"]');
    if (!btn) return;
    if (btn.closest('quick-add-modal')) return;  /* leave Dawn's own variant modal alone */

    e.preventDefault();
    e.stopPropagation();

    activeForm = btn.closest('form');
    var card = btn.closest('.card-wrapper') || btn.closest('li');
    var heading = card && card.querySelector('.card__heading');
    titleEl.textContent = heading ? heading.textContent.trim() : 'Choose quantity';
    input.value = 1;
    modal.hidden = false;
    document.body.style.overflow = 'hidden'; /* lock page scroll behind backdrop, like Bootstrap */
    requestAnimationFrame(function () { modal.classList.add('is-open'); });
  }, true);
})();